export enum CustomAttributeFieldType {
  Date = 'date',
  DepartmentMultiSelect = 'departmentmultiselect',
  Link = 'link',
  MultiSelect = 'multiselect',
  Select = 'select',
  Text = 'text',
  Textarea = 'textarea',
  UserMultiSelect = 'usermultiselect',
}

export type Tagged<T extends string, U> = { _tag: T } & U;
interface Option {
  Value: string;
  GeneratedId: `${string}-${string}-${string}-${string}-${string}`;
}
export type StringOption = Tagged<'StringOption', Option>;
export type AltValueOption = Tagged<
  'AltValueOption',
  Option & { AltValue: string }
>;
export type FormFieldOption = StringOption | AltValueOption;
